<template>
  <div>
    <div v-if="item">
      <div v-if="item && item.tmdb">
        <div style="display: flex; justify-content: left">
          <!-- poster -->
          <div style="margin-right: 10px">
            <img :src="item.tmdb.poster_url" :alt="item.tmdb.title" style="max-width: 100px; border-radius: 8px" />
          </div>
          <div>
            <h1 style="line-height: normal">{{ item.tmdb.title || item.tmdb.name }}</h1>
            <div v-if="item.imdb">
              <!-- tagline -->
              <div v-if="item.tmdb.tagline">
                <i>{{ item.tmdb.tagline }} </i>
              </div>
            </div>

            <!-- ratings -->
            <div style="display: flex; gap: 10px">
              <!-- imdb -->
              <div v-if="item.imdb && item.imdb.rating && item.imdb.rating.aggregateRating">
                <a :href="`https://www.imdb.com/title/${item.imdb_id}/`">
                  <div
                    style="
                      color: black;
                      background-color: #f5c518;
                      border: 1px solid black;
                      padding: 2px 8px;
                      border-radius: 5px;
                      display: inline-block;
                      margin-right: 2px;
                      font-weight: bold;
                    "
                  >
                    {{ item.imdb.rating.aggregateRating }}
                  </div></a
                >
              </div>

              <!-- filmaffinity -->
              <div v-if="item.filmaffinity">
                <a :href="item.filmaffinity.url">
                  <div
                    style="
                      color: white;
                      background-color: #4682b4;
                      border: 1px solid #5b8fbb;
                      padding: 2px 8px;
                      border-radius: 5px;
                      display: inline-block;
                      margin-right: 2px;
                    "
                  >
                    {{ item.filmaffinity.rating }}
                  </div>
                </a>
              </div>

              <!-- tmdb -->
              <div v-if="item.tmdb && item.tmdb.vote_average && false">
                <div
                  style="
                    background-color: #21d07a;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 50%;
                    height: 100%;
                    font-weight: bold;
                    font-size: 80%;
                  "
                >
                  {{ item.tmdb.vote_average.toFixed(1) * 10 }}%
                </div>
              </div>
            </div>

            <!-- genres -->
            <div v-if="item.tmdb.genres">
              {{ item.tmdb.genres.map((x) => x.name).join(', ') }}
            </div>

            <!-- meta-->
            <div>
              <span v-if="false && item.imdb.rating && item.imdb.rating.aggregateRating > 0">
                {{ Math.round(item.imdb.rating.aggregateRating * 100) / 100
                }}<v-icon color="orange" class="mb-1" small>mdi-star</v-icon>
              </span>

              <span v-if="item.imdb.startYear"> {{ item.imdb.startYear }} </span>
              <span v-if="item.tmdb.runtime"> | {{ item.tmdb.runtime }}min </span>
            </div>
          </div>
        </div>
        <div style="display: flex; align-content: center">
          <!-- action buttons -->
          <div v-if="false" style="display: flex; flex-direction: column; justify-content: left; margin-left: 10px">
            <div>
              <v-btn
                depressed
                x-large
                icon
                class="mb-1"
                color="primary"
                @click="engagement('bookmark', bookmarked ? 'remove' : 'add')"
              >
                <v-icon v-if="!bookmarked" class="mr-4" large>mdi-bookmark-outline</v-icon>
                <v-icon v-if="bookmarked" class="mr-4" large>mdi-bookmark</v-icon>
              </v-btn>
              <span v-if="false">La quiero ver</span>
            </div>
            <div>
              <v-btn
                depressed
                x-large
                icon
                class="mb-1"
                color="primary"
                @click="engagement('recommend', recommended ? 'remove' : 'add')"
              >
                <v-icon v-if="!recommended" class="mr-4" large>mdi-thumb-up-outline</v-icon>
                <v-icon v-if="recommended" class="mr-4" large>mdi-thumb-up</v-icon>
              </v-btn>
              <span v-if="false">La recomiendo</span>
            </div>
            <div>
              <v-btn
                depressed
                x-large
                icon
                class="mb-1"
                color="primary"
                @click="engagement('hide', hidden ? 'remove' : 'add')"
              >
                <v-icon v-if="!hidden" class="mr-4" large>mdi-eye-off-outline</v-icon
                ><v-icon v-if="hidden" class="mr-4" large>mdi-eye-off</v-icon></v-btn
              ><span v-if="false">No me interesa</span>
            </div>
          </div>
        </div>

        <!-- action buttons -->
        <div v-if="false" style="display: flex; justify-content: left">
          <div>
            <v-btn
              depressed
              x-large
              icon
              class="mb-1"
              color="primary"
              @click="engagement('bookmark', bookmarked ? 'remove' : 'add')"
            >
              <v-icon v-if="!bookmarked" class="mr-4" large>mdi-bookmark-outline</v-icon>
              <v-icon v-if="bookmarked" class="mr-4" large>mdi-bookmark</v-icon>
            </v-btn>
            <span v-if="false">La quiero ver</span>
          </div>
          <div>
            <v-btn
              depressed
              x-large
              icon
              class="mb-1"
              color="primary"
              @click="engagement('recommend', recommended ? 'remove' : 'add')"
            >
              <v-icon v-if="!recommended" class="mr-4" large>mdi-thumb-up-outline</v-icon>
              <v-icon v-if="recommended" class="mr-4" large>mdi-thumb-up</v-icon>
            </v-btn>
            <span v-if="false">La recomiendo</span>
          </div>
          <div>
            <v-btn
              depressed
              x-large
              icon
              class="mb-1"
              color="primary"
              @click="engagement('hide', hidden ? 'remove' : 'add')"
            >
              <v-icon v-if="!hidden" class="mr-4" large>mdi-eye-off-outline</v-icon
              ><v-icon v-if="hidden" class="mr-4" large>mdi-eye-off</v-icon></v-btn
            ><span v-if="false">No me interesa</span>
          </div>
        </div>

        <!-- newest version with user lists-->
        <div style="margin: 8px 0px">
          <h3>Mis Listas</h3>

          <div style="display: flex">
            <div v-for="(list, i) in my_lists" :key="i">
              <v-chip label class="mr-1" @click="toggleList(list.id)"
                >{{ list.name }}

                {{ list.items.includes(tmdb_id) ? '✅' : '' }}
              </v-chip>
            </div>
          </div>
        </div>

        <!-- simpler version  -->
        <div v-if="false">
          <v-btn
            :outlined="bookmarked"
            color="primary"
            block
            depressed
            @click="engagement('bookmarked', bookmarked ? 'remove' : 'add')"
            class="mb-1"
            >{{ bookmarked ? 'Quitar de mi lista ' : 'Añadir a mi lista' }}</v-btn
          >
          <v-btn
            :outlined="watched"
            color="primary"
            block
            depressed
            @click="engagement('watched', watched ? 'remove' : 'add')"
            class="mb-1"
            >{{ watched ? 'Marcar como no vista' : 'Marcar como vista' }}</v-btn
          >

          <div v-if="watched">
            <v-btn
              :outlined="recommended"
              color="primary"
              block
              depressed
              @click="engagement('recommended', recommended ? 'remove' : 'add')"
              class="mb-1"
              >{{ recommended ? 'Dejar de recomendar' : 'Recomendar' }}</v-btn
            >

            <!-- my own review -->
            <div style="margin-top: 10px">
              <h3>Mi review</h3>
              <v-textarea
                outlined
                v-model="myreview"
                rows="3"
                :placeholder="recommended ? '¿Por qué la recomiendas?' : '¿Qué opinas?'"
                @change="saveReview"
              ></v-textarea>
              <v-btn v-if="false" @click="saveReview" color="primary" block>guardar</v-btn>
            </div>
          </div>
        </div>

        <!-- reviews from others -->
        <div style="margin-top: 20px">
          <h2>Nuestras reviews</h2>
          <div v-if="reviews.length">
            <div v-for="review in reviews" :key="review.author">
              <!-- show all reviews but mine -->
              <!-- <div v-if="review.author != username"> -->
              <div style="margin-top: 10px; padding: 10px; border: 1px solid #ccc; border-radius: 5px">
                <h3>
                  {{ review.author }}
                  <span v-if="review.recommends" style="color: green; font-size: 80%">La recomienda!</span>
                </h3>
                <p>
                  {{ review.text || 'No hay detalles' }}
                </p>
              </div>
            </div>
          </div>
          <div v-else>No hay reviews</div>
        </div>

        <!-- hide switch -->
        <div>
          <v-switch v-if="false" :loading="loading2" label="Ocultar" v-model="hidden" hide-details></v-switch>
        </div>

        <!-- poster -->
      </div>

      <!-- just watch -->
      <div v-if="item && item.justwatch">
        <h2>JustWatch <a class="modern-link" :href="item.justwatch.link">detalles</a></h2>
        <div v-for="jw in jw_options" :key="jw.type">
          <div v-if="item.justwatch[jw.type]">
            <h3>{{ jw.name }}</h3>
            <div style="display: flex">
              <div v-for="provider in item.justwatch[jw.type]" :key="provider.id">
                <div style="margin-right: 10px">
                  <img
                    width="50px"
                    style="border-radius: 12px; border: 1px solid #ccc"
                    :src="'https://image.tmdb.org/t/p/w200' + provider.logo_path"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      <!-- parentsGuide -->
      <div>
        <h2>Parents Guide</h2>
        <div v-if="item && item.parentsGuide">
          <div v-for="pg in item.parentsGuide" :key="pg.category">
            <div>
              <b>
                {{ parentGuideCategories.find((x) => x.key == pg.category).name }}
              </b>

              : {{ pg.level }} ({{ pg.votes }} votes)
            </div>
          </div>
        </div>
      </div>

      <!-- plot -->
      <div style="">
        <h2>Argumento</h2>
        <p>{{ item && item.tmdb ? item.tmdb.overview : '' }}</p>
      </div>

      <!-- [imdb] stars (actors) -->
      <div v-if="!item.credits && item.imdb && item.imdb.stars">
        <h2>Actores</h2>
        <div v-if="item.imdb.stars" style="display: flex; margin-top: 10px; overflow-x: auto">
          <div v-for="star in item.imdb.stars" :key="star.id" style="margin-right: 10px">
            <a :href="`https://www.imdb.com/name/${star.id}/`" class="no-link" style="max-width: 85px">
              <div>
                <img
                  :src="star.primaryImage.url"
                  style="width: 80px; height: 80px; object-fit: cover; border-radius: 50%"
                  :alt="star.displayName"
                />
              </div>
              <div style="text-align: center">
                {{ star.displayName }}
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- [tmdb] cast -->
      <div v-if="item.credits">
        <h2>Actores</h2>
        <div v-if="item.credits && item.credits.cast" style="display: flex; margin-top: 10px; overflow-x: auto">
          <div v-for="person in item.credits.cast" :key="person.id" style="margin-right: 10px">
            <a :href="`https://www.themoviedb.org/person/${person.id}`" class="no-link" style="max-width: 100px">
              <div>
                <img
                  :src="personImage(person)"
                  style="width: 90px; height: 90px; object-fit: cover; border-radius: 50%"
                  :alt="person.name"
                />
              </div>
              <div style="text-align: center; line-height: normal">
                <b>
                  {{ person.name }}
                </b>
                <br />
                {{ person.character }}
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- seasons -->
      <div v-if="item.tmdb && item.tmdb.seasons">
        <h2>{{ item.tmdb.seasons.length }} temporadas</h2>
        <div v-for="(season, index) in item.tmdb.seasons" :key="index">
          <MovieListItem :item="season" />
        </div>
      </div>

      <!-- collection -->
      <div v-if="item.collection">
        <h2>Colección</h2>
        <div></div>
        <div v-if="item.collection.parts">
          <div v-for="(part, index) in item.collection.parts" :key="index">
            <MovieListItem :item="part" />
          </div>
        </div>
      </div>

      <br />
      <hr />
      <br />

      <!-- useful links -->
      <div style="display: flex; gap: 10px">
        <!-- imdb -->
        <div v-if="item.imdb && item.imdb.rating && item.imdb.rating.aggregateRating">
          <a :href="`https://www.imdb.com/title/${item.imdb_id}/`" target="_blank" rel="noopener noreferrer">
            <div
              style="
                color: black;
                background-color: #f5c518;
                border: 1px solid black;
                padding: 2px 8px;
                border-radius: 5px;
                display: inline-block;
                margin-right: 2px;
                font-weight: bold;
              "
            >
              IMDb
              <span style="font-size: 130%">
                {{ item.imdb.rating.aggregateRating }}
              </span>
            </div></a
          >
        </div>

        <!-- filmaffinity -->
        <div v-if="item.filmaffinity">
          <a :href="item.filmaffinity.url" target="_blank" rel="noopener noreferrer">
            <div
              style="
                color: white;
                background-color: #4682b4;
                border: 1px solid #5b8fbb;
                padding: 2px 8px;
                border-radius: 5px;
                display: inline-block;
                margin-right: 2px;
              "
            >
              Filmaffinity
              <span style="font-size: 130%">
                {{ item.filmaffinity.rating }}
              </span>
            </div>
          </a>
        </div>
      </div>

      <!-- filmaffinity critics -->
      <div><!-- TODO --></div>

      <div v-if="false" style="margin-top: 50px; font-size: 50%; font-family: monospace">
        {{ item }}
      </div>

      <!-- added by -->
      <div style="margin-top: 20px">
        <div>Añadido por {{ item.createdBy }} en {{ item.createdAt }}</div>
      </div>
    </div>
    <div v-else style="height: 500px">Loading...</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/assets/api'
import MovieListItem from './MovieListItem.vue'
export default {
  components: {
    MovieListItem,
  },
  data() {
    return {
      item: null,
      loading: false,
      tab: 0,
      my_lists: [],

      //
      loading2: false,
      myreview: '',

      parentGuideCategories: [
        { key: 'SEXUAL_CONTENT', name: 'Sex & Nudity' },
        { key: 'FRIGHTENING_INTENSE_SCENES', name: 'Frightening & Intense Scenes' },
        { key: 'VIOLENCE', name: 'Violence' },
        { key: 'PROFANITY', name: 'Profanity' },
        { key: 'ALCOHOL_DRUGS', name: 'Alcohol, Drugs & Smoking' },
      ],

      jw_options: [
        { type: 'flatrate', name: 'Subscripción' },
        { type: 'ads', name: 'Con Anuncios' },

        { type: 'rent', name: 'Alquilar' },
        { type: 'buy', name: 'Comprar' },
      ],
    }
  },
  props: {
    tmdb_id: {
      type: String,
      default: '',
    },
  },
  watch: {
    tmdb_id(newValue, oldValue) {
      this.item = null
      this.fetchData()
    },
  },
  computed: {
    ...mapGetters(['username']),
    reviews() {
      let x = []
      if (!this.item || !this.item.engagement) return []
      if (this.item.engagement.reviews) {
        x = [...this.item.engagement.reviews.filter((r) => r.text)]
        for (let i = 0; i < x.length; i++) {
          const review = x[i]
          review.recommends = false
          if (this.item.engagement.recommended && this.item.engagement.recommended.includes(review.author)) {
            review.recommends = true
          }
        }
      }
      if (this.item.engagement.recommended) {
        for (let i = 0; i < this.item.engagement.recommended.length; i++) {
          const u = this.item.engagement.recommended[i]
          if (!x.find((r) => r.author == u)) {
            x.push({ author: u, recommends: true, text: '' })
          }
        }
      }
      //TODO: hide the reviews from self (commended to have preview during dev.)
      //x = x.filter((r) => r.author != this.username)
      return x
    },
    bookmarked() {
      return this.item?.engagement?.bookmarked?.includes(this.username)
    },
    recommended() {
      return this.item?.engagement?.recommended?.includes(this.username)
    },
    hidden() {
      return this.item?.engagement?.hiden?.includes(this.username)
    },
    watched() {
      return this.item?.engagement?.watched?.includes(this.username)
    },
  },
  methods: {
    async toggleList(list_id) {
      const lists = [...this.my_lists]
      const list = lists.find((l) => l.id == list_id)
      let pathh = 'nothing'
      if (!list.items) list.items = []
      if (list.items.find((i) => i == this.tmdb_id)) {
        //remove
        list.items = list.items.filter((i) => i != this.tmdb_id)
        pathh = 'list-remove-movie'
      } else {
        //add
        list.items.push(this.tmdb_id)
        pathh = 'list-add-movie'
      }
      const x = await api.apiFetch(`/watchlistt/${pathh}?list_id=${list.id}&tmdb_id=${this.tmdb_id}`, {
        method: 'POST',
        body: JSON.stringify({}),
      })
      if (!x.ok) return alert('something failed')
      this.my_lists = [...lists]
    },
    personImage(person) {
      if (person.profile_path) return `https://image.tmdb.org/t/p/w200${person.profile_path}`

      //no image:

      //female
      if (person.gender == 1) {
        return 'https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-36-user-female-grey-d9222f16ec16a33ed5e2c9bbdca07a4c48db14008bbebbabced8f8ed1fa2ad59.svg'
      }

      //male
      if (person.gender == 2) {
        return 'https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-4-user-grey-d8fe957375e70239d6abdd549fd7568c89281b2179b5f4470e2e12895792dfa5.svg'
      }
    },
    async fetchMyLists() {
      //get my lists, get items in those lists, and use it to quickly add/remove this movie from lists
      //note: this could be cached somewhere
      const x = await api.apiFetch('/watchlistt/my-lists')
      const j = await x.json()
      const lists = []
      for (let i = 0; i < j.lists.length; i++) {
        const list_id = j.lists[i]
        const k = await api.apiFetch('/watchlistt/list?id=' + list_id)
        if (k.ok) {
          const list_data = await k.json()
          lists.push(list_data)
        }
      }
      this.my_lists = [...lists]
    },
    async fetchData() {
      this.loading = true
      this.fetchMyLists()
      const x = await api.apiFetch('/watchlistt/get-movie?tmdb_id=' + this.tmdb_id + '&force=true')
      if (!x.ok) this.item = null

      const j = await x.json()

      //sort collection:
      if (j.collection && j.collection.parts) {
        j.collection.parts = j.collection.parts.sort(
          (a, b) => new Date(a.release_date || Infinity) - new Date(b.release_date || Infinity)
        )
      }
      this.item = j

      this.myreview = this.item?.engagement?.reviews.find((x) => x.author === this.username)?.text || ''

      this.loading = false
    },

    async engagement(type, action) {
      this.loading2 = true
      const path = `/watchlistt/engagement`
      const x = await api.apiFetch(path, {
        method: 'POST',
        body: JSON.stringify({
          type,
          action,
          tmdb_id: this.tmdb_id,
        }),
      })
      if (x.ok) this.item = await x.json()
      this.loading2 = false
    },
    async saveReview() {
      const path = `/watchlistt/engagement`
      const x = await api.apiFetch(path, {
        method: 'POST',
        body: JSON.stringify({
          tmdb_id: this.tmdb_id,
          type: 'reviews',
          action: 'add',
          text: this.myreview,
        }),
      })
      if (x.ok) this.item = await x.json()
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped lang="scss">
h2 {
  margin-top: 23px;
  margin-bottom: 8px;
}
h3 {
  margin-top: 12px;
  margin-bottom: 8px;
}

.no-link {
  color: var(--v-theme-on-background);
}

.no-link:hover {
  color: var(--v-theme-on-background);
  text-decoration: none;
}
.no-link:visited {
  color: var(--v-theme-on-background);
}
</style>
